// @ts-nocheck
import * as React from "react";

const SaveLine: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M20 7.423v10.961c0 .46-.154.845-.462 1.154a1.565 1.565 0 0 1-1.154.462H5.616c-.46 0-.845-.154-1.153-.462A1.565 1.565 0 0 1 4 18.384V5.616c0-.46.154-.845.463-1.153A1.565 1.565 0 0 1 5.615 4h10.962L20 7.423Zm-1 .427L16.15 5H5.616a.6.6 0 0 0-.443.173.6.6 0 0 0-.173.442v12.77a.6.6 0 0 0 .173.442.6.6 0 0 0 .442.173h12.77a.6.6 0 0 0 .442-.173.6.6 0 0 0 .173-.443V7.85Zm-7 8.688c.551 0 1.023-.195 1.414-.586.39-.391.586-.862.586-1.413 0-.552-.195-1.023-.586-1.414A1.927 1.927 0 0 0 12 12.539c-.551 0-1.023.195-1.414.586A1.927 1.927 0 0 0 10 14.539c0 .55.195 1.022.586 1.413.391.391.863.586 1.414.586ZM6.77 9.77h7.422v-3H6.77v3ZM5 7.85V19 5v2.85Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export default React.memo(SaveLine);
